import "babel-polyfill"
import * as React from "react"
import * as ReactDOM from "react-dom"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import App from "./components/App/App"
import Results from "./components/Results/Results"
import "../src/assets/styles/main.scss"

import { Provider } from "mobx-react"
import { LayoutStore } from "./store/LayoutStore"
import { UserStore } from "./store/UserStore"
import { WeekConsumptionStore } from "./store/WeekConsumptionStore"
import { ResultStore } from "./store/ResultStore"
import RouterNoMatch from "./components/RouterNoMatch/RouterNoMatch"
import Layout from "./components/Layout/Layout"

ReactDOM.render(
  // Provider is used to give the possibility to inject stores into childrens components of provider
  <Provider
    LayoutStore={LayoutStore}
    UserStore={UserStore}
    WeekConsumptionStore={WeekConsumptionStore}
    ResultStore={ResultStore}
  >
    <Layout>
      <Router>
          {/* The props 'exact' must be set.
                Otherwise the path /results also match / meaning that we have App and Results components shown */}
          <Switch>
            <Route exact={true} path="/" component={App} />
            <Route exact={true} path="/results" component={Results} />
            <Route component={RouterNoMatch} />
          </Switch>
      </Router>
    </Layout>
  </Provider>,
  document.getElementById("root") as HTMLElement
)



// WEBPACK FOOTER //
// ./src/index.tsx